import * as api from '../api/index'
import { AUTH, ALL_USERS } from '../actions/constant'

export const signin =(formData, history) => async(dispatch) => {

    try {
        //login the user
        const { data } = await api.signIn(formData)

        dispatch({ type: AUTH, data})

        history.push('/birdit')

    } catch (error) {
        console.log(error.response.data)
    }
}


export const signup =(formData, history) => async(dispatch) => {

    try {
        //Sign up the user
        const { data } = await api.signUp(formData)

        dispatch({ type: AUTH, data})

        history.push('/birdit')

    } catch (error) {
        console.log(error.response.data)
    }
}

export const getUsers = () => async (dispatch)=> {
    try {
        const { data } = await api.fetchUsers()
        dispatch({ type: ALL_USERS, payload: data })
    } catch (error) {
        console.log(error)
    }
}
